import React from "react";

import PrePlayActive from "../components/PrePlayActive";
import PrePlayCommon from "../components/PrePlayCommon";

const GAHPrePlay = ({ roomId, status, playerObj, isActivePlayer }) => {
  return isActivePlayer ? (
    <PrePlayActive roomId={roomId} />
  ) : (
    <PrePlayCommon status={status} playerObj={playerObj} />
  );
};

export default GAHPrePlay;
